import { z } from "zod";

import { JobsScrapeStatus } from "@/enum/scrape-enum";
import { MetaDataSchema } from "@/schemas/meta-data";
import { ERROR_TYPE } from "@/utils";

import { ScrapeLevel } from "@/enum/job.enum";

import { ListStatus } from "@/enum/list.enum";

import { SuggestionSchema } from "../../LiPeople/schema/liPeople";
import { OfferSchema } from "./offer";

const { REQUIRED } = ERROR_TYPE;

export const JobSchema = z.object({
	id: z.number(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	query: z.string().min(2, { message: REQUIRED }).trim(),
	employmentType: z.string().nullable().optional(),
	offers: z.array(OfferSchema),
	status: z.nativeEnum(JobsScrapeStatus),
	activeStatus: z.nativeEnum(ListStatus),
	jobScrapeType: z.nativeEnum(ScrapeLevel),
	repeatDaily: z.boolean(),
	inTitle: z.boolean(),
	location: SuggestionSchema,
	positionTitles: z.array(z.string()).optional(),
});

export const PreviewJobRequestSchema = z.object({
	listId: z.number(),
	query: z.string(),
	country: z.string(),
	employmentType: z.string(),
	inTitle: z.boolean(),
});

export const PreviewJobOfferSchema = z.object({
	id: z.string(),
	title: z.string(),
	acceptingApplications: z.boolean(),
	applicants: z.number(),
	companyName: z.string(),
	linkedinCompanyName: z.string(),
	location: z.string(),
	postedTimeAgo: z.string(),
	seniorityLevel: z.string(),
	employmentType: z.string(),
	jobFunction: z.string(),
	industries: z.string(),
	description: z.string(),
	linkedinUrl: z.string(),
	datePosted: z.string().optional(),
});

export const PreviewJobOfferResponseSchema = z.object({
	data: z.array(PreviewJobOfferSchema),
	meta: MetaDataSchema,
});

export const CreateJobSchema = z.object({
	id: z.number().optional(),
	name: z.string().min(2, { message: REQUIRED }).trim(),
	query: z.string().min(2, { message: REQUIRED }).trim(),
	employmentType: z.string().nullable().optional(),
	jobScrapeType: z.nativeEnum(ScrapeLevel),
	repeatDaily: z.boolean(),
	inTitle: z.boolean(),
	listId: z.number().optional(),
	location: SuggestionSchema,
	positionTitles: z.array(z.string()).optional(),
});

export const ToggleJobSchema = z.object({
	id: z.number(),
	activeStatus: z.nativeEnum(ListStatus),
});

export const JobResponseSchema = z.object({
	data: z.array(JobSchema),
	meta: MetaDataSchema,
});

export type Job = z.infer<typeof JobSchema>;

export type ToggleJob = z.infer<typeof ToggleJobSchema>;

export type CreateJob = z.infer<typeof CreateJobSchema>;

export type JobResponse = z.infer<typeof JobResponseSchema>;

export type PreviewJobOffer = z.infer<typeof PreviewJobOfferSchema>;

export type PreviewJobOfferResponse = z.infer<typeof PreviewJobOfferResponseSchema>;

export type PreviewJobRequest = z.infer<typeof PreviewJobRequestSchema>;
